import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the easySplitDetails state domain
 */

const selectEasySplitDetailsDomain = state =>
  state.easySplitDetails || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by EasySplitDetails
 */

const makeSelectEasySplitDetails = () =>
  createSelector(
    selectEasySplitDetailsDomain,
    substate => substate,
  );

export default makeSelectEasySplitDetails;
export { selectEasySplitDetailsDomain };
